import React from 'react';

import deleteIcon from 'assets/sidebar-delete.svg';

const SidebarDeleteIcon = ({
  onClick,
  className,
}: {
  onClick: () => void;
  className?: string;
}): JSX.Element => (
  <img
    src={deleteIcon}
    alt="delete-icon"
    className={className}
    onClick={() => onClick()}
  />
);

export default SidebarDeleteIcon;
